import { render, staticRenderFns } from "./FinalDetails.vue?vue&type=template&id=509d0436&scoped=true&"
import script from "./FinalDetails.vue?vue&type=script&lang=ts&"
export * from "./FinalDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FinalDetails.vue?vue&type=style&index=0&id=509d0436&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d0436",
  null
  
)

export default component.exports